import { render, staticRenderFns } from "./LoadingField.vue?vue&type=template&id=22a8b98b&"
import script from "./LoadingField.vue?vue&type=script&lang=js&"
export * from "./LoadingField.vue?vue&type=script&lang=js&"
import style0 from "./LoadingField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports